import React from "react"
import styled from "styled-components"
import RunCycle from "../../../public/static/images/runcycle.gif"

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Runner = () => {
  return (
    <Center>
      <img src={RunCycle} alt="loading" />
    </Center>
  )
}

export default Runner
